import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const mockupRadiusServer = {
  "jsonrpc": "2.0",
  "id": "174bba2e-2772-4c85-971b-06dff8a3e3bb",
  "data": [
    {
      "id": "72f31915-1a91-4996-9284-17ae03811111",
      "version": 2,
      "name": "Radius Server 1",
      "referencedServices": ["ssid-test-1", "ssid-test-test-2", "ssid-test-test-test-3", "ssid-test-test-test-test-4", "ssid-test-test-test-test-test-5"],
      "primary": {
        "accountingType": "independent",
        "authenticateServer": "192.168.0.87",
        "authenticationType": "PAP",
        "port": 1,
        "secret": "12345678",
        "accounting": {
          "accountingServer": "192.168.0.88",
          "authenticationType": "PAP",
          "port": 7,
          "secret": "password1"
        }
      },
      "secondary": {
        "accountingType": "disable",
        "authenticateServer": "192.168.0.6",
        "authenticationType": "MSCHAPV2",
        "port": 2,
        "secret": "87654321",
        "accounting": {
          "accountingServer": "192.168.0.88",
          "authenticationType": "PAP",
          "port": 7,
          "secret": "password1"
        }
      }
    },
    {
      "id": "72f31915-1a91-4996-9284-17ae03822222",
      "version": 2,
      "name": "Radius Server 2",
      "referencedServices": ["ssid-test-test-test-3", "ssid-test-test-test-test-4", "ssid-test-test-test-test-test-5"],
      "primary": {
        "accountingType": "independent",
        "authenticateServer": "192.168.0.97",
        "authenticationType": "PAP",
        "port": 1,
        "secret": "12345678",
        "accounting": {
          "accountingServer": "192.168.0.99",
          "authenticationType": "PAP",
          "port": 7,
          "secret": "password2"
        }
      },
      "secondary": {
        "accountingType": "disable",
        "authenticateServer": "192.168.0.9",
        "authenticationType": "MSCHAPV2",
        "port": 3,
        "secret": "87654321",
        "accounting": {
          "accountingServer": "192.168.0.88",
          "authenticationType": "PAP",
          "port": 7,
          "secret": "password2"
        }
      }
    },
  ]
}

export const profilesRadiusServerSlice = createSlice({
  name: "profilesRadiusServer",
  initialState: mockupRadiusServer,
  reducers: {
    createProfilesRadiusServer: (state, action) => {
      const newRadius = {...action.payload, id: uuidv4()}; // fake id.
      if (action?.payload) state.data = [...state.data, structuredClone(newRadius)];
    },
    updateProfilesRadiusServer: (state, action) => {
      if (action?.payload) {
        const index = state.data.findIndex(radius => radius.id === action.payload.id);

        if (index !== -1) {
          state.data[index] = structuredClone(action.payload);
        }
      }
    },
    deleteProfilesRadiusServer: (state, action) => {
      if (action?.payload?.ids) {
        const remainRadiusList = state.data.filter(radius => !action.payload.ids.includes(radius.id));
        state.data = remainRadiusList;
      }
    },
  },
});

export const {
  createProfilesRadiusServer,
  updateProfilesRadiusServer,
  deleteProfilesRadiusServer,
} = profilesRadiusServerSlice.actions;

export default profilesRadiusServerSlice.reducer;
